import apiClient from './apiClient';

export interface QueryParams {
  PR_START_01?: string;  // current year start YYYYMM
  PR_LAST_01?: string;   // current year end YYYYMM
  PR_START_04?: string;  // comparison year start YYYYMM
  PR_LAST_04?: string;   // comparison year end YYYYMM
  PR_START_02?: string;  // vendor from
  PR_LAST_02?: string;   // vendor to
  PR_START_03?: string;  // item from
  PR_LAST_03?: string;   // item to
  PR_START_05?: string;  // dept from
  PR_LAST_05?: string;   // dept to
}

export interface PurchaseRow {
  FD110_12: string;    // vendor code
  vendor_name: string;
  item_code: string;   // FD111_10 + FD111_11 concatenated
  FD111_10: string;
  FD111_11: string;
  FD111_16: string;    // unit
  cur_qty: number;
  cur_amt: number;
  cmp_qty: number;
  cmp_amt: number;
}

export interface UnitSummary {
  FD111_16: string;  // unit
  cur_qty: number;
  cmp_qty: number;
  cur_amt: number;
  cmp_amt: number;
}

export interface QueryResponse {
  data: PurchaseRow[];
  count: number;
  unit_summary: UnitSummary[];
  message?: string;
}

export const pwd307Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwd307/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pwd307/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
